import Table from './table.js';
import events from './event.js';
import products from './products.js';
import Storage from './storage.js';
import { textString } from './texts.js';
import _ from './translate.js';
import Logger from './logger.js';

class SelectProduct {
    customizerContentDiv = null;
    attr = null;
    wrapperDiv = null;
    selectProductDiv = null;

    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;
        if (!this.customizerContentDiv) {
            Logger.error('SelectProduct step failed to load.');
            return;
        }
        this.init();
    }

    async init() {
        await this.createWrapper();
        await this.createTable();
        this.addListeners();
    }

    async createWrapper() {
        if (this.wrapperDiv) {
            // If already initialized, just show the wrapper
            this.wrapperDiv.style.display = 'flex';
            return;
        }
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-selectProduct-wrapper');
        this.customizerContentDiv.appendChild(this.wrapperDiv);

        // create select product div
        this.selectProductDiv = document.createElement('div');
        this.selectProductDiv.classList.add('mscp-selectProduct-list', 'mscp-table');
        this.wrapperDiv.appendChild(this.selectProductDiv);
    }

    async createTable() {
        // create size list
        const theProducts = await products.getProducts();
        if (!theProducts || theProducts.length === 0) {
            Logger.warn('No products found');
            return;
        }

        this.table = new Table({
            'wrapperDiv': this.selectProductDiv,
            'terms': theProducts,
            'type': 'selectProduct'
        });
    }

    async update() {
        const currentProductIds = await products.getAttributeHierarchyProductIDs();
        if (!currentProductIds || currentProductIds.length === 0) {
            Logger.warn('No products available for the selected presentation and paper');
            return;
        }

        if (currentProductIds.length === 1) {
            // If only one product is available, select it automatically and navigate to the next step
            const theProductId = currentProductIds[0];
            Storage.save('selectProduct', theProductId);

            this.selectProductDiv.innerHTML = ''; // Clear the product list
            const message = document.createElement('div');
            message.classList.add('mscp-no-items');
            message.innerHTML = textString('selectProduct_processing');
            this.selectProductDiv.appendChild(message);

            // TODO: preload the product page

            events.trigger('changeStep', 'next'); // Navigate to the next step
            return;
        }

        this.table.updateVisibleItems(currentProductIds);

    }

    addListeners() {
        events.add('stepChanged', (step) => {
            if (step === 'selectProduct') {
                this.update();
            }
        });
    }


}

export default SelectProduct;